import { Modal } from "@/components/common/Modal/Modal"
import { toast } from "@/components/common/Toast"
import {
  TranslationProvider,
  useTranslation,
} from "@/hooks/useTranslation/useTranslation"
import { IconDatabaseSearch, IconLink } from "@tabler/icons-react"

interface AskForHelpModalProps {
  responsePairId: string
  setIsAskForHelpModalOpen: (isOpen: boolean) => void
}

export const AskForHelpModal: React.FC<AskForHelpModalProps> = ({
  responsePairId,
  setIsAskForHelpModalOpen,
}) => {
  const { translate } = useTranslation()
  const handleCloseShareModal = () => {
    setIsAskForHelpModalOpen(false)
  }

  const handleCopyQuestionLink = () => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set("question", responsePairId)
    const url = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`
    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.warning(translate("QUESTIONNAIRE_ANSWERS/LINK_COPIED_TOAST"))
      })
      .catch(() => {
        toast.error(translate("QUESTIONNAIRE_ANSWERS/LINK_COPIED_ERROR"))
      })
    setIsAskForHelpModalOpen(false)
  }

  return (
    <TranslationProvider>
      <Modal
        showSidebarLeft
        ModalIcon={IconDatabaseSearch}
        descriptionText={translate(
          "QUESTIONNAIRE_ANSWERS/ASK_FOR_HELP_MODAL_TEXT",
        )}
        primaryActionTitle={translate(
          "QUESTIONNAIRE_ANSWERS/ASK_FOR_HELP_MODAL_COPY",
        )}
        primaryActionIcon={IconLink}
        secondaryActionTitle={translate(
          "QUESTIONNAIRE_ANSWERS/ASK_FOR_HELP_MODAL_CLOSE",
        )}
        onClose={handleCloseShareModal}
        onPrimaryAction={() => handleCopyQuestionLink()}
        onSecondaryAction={handleCloseShareModal}
      ></Modal>
    </TranslationProvider>
  )
}
